import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL;

export default new (class {
	async getAll(facilityId) {
		const response = await axios.get(
			`${API_URL}/api/Cms/Facilities?facilityId=${facilityId}`,
			{
				withCredentials: true,
				headers: {
					'Cache-control': 'no-cache'
				}
			}
		);
		return response.data;
	}
	async getAllByUser() {
		const response = await axios.get(`${API_URL}/api/Cms/UserFacilities`, {
			withCredentials: true,
			headers: {
				'Cache-control': 'no-cache'
			}
		});
		return response.data;
	}
	async getById(facilityId) {
		const url =
			facilityId !== null && facilityId !== undefined
				? `/api/Cms/Facility?id=${facilityId}`
				: `/api/Cms/Facility`;

		const response = await axios.get(`${API_URL}${url}`, {
			withCredentials: true,
			headers: {
				'Cache-control': 'no-cache'
			}
		});
		return response.data;
	}
	async update(facilityData) {
		try {
			await axios.put(`${API_URL}/api/Cms/Facility`, facilityData, {
				withCredentials: true,
				headers: {
					'Cache-control': 'no-cache'
				}
			});
		} catch (error) {
			console.error('Error:', error);
			throw error;
		}
	}
	async deleteById(facilityId) {
		try {
			await axios.delete(`${API_URL}/api/Cms/Facility?id=${facilityId}`, {
				withCredentials: true,
				headers: {
					'Cache-control': 'no-cache'
				}
			});
		} catch (error) {
			console.error('Error deleting by ID:', error);
			throw error;
		}
	}
})();
